module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Commit-853f182809666ac7a10c81ed12eb85f9.svg";